import { Fragment, useEffect, useState } from "react";
// import CellAccordion from "./CellAccordion";
import { useDashboardUIContext } from "@contexts/dashboardUI";
import { checkIfMultipleIds, unitsIntoArray } from "@utils/checkMultipleIds";
import ProjectionLoadState from "../ProjectionLoadState";
import TableItem from "./TableItem";
import CellAccordion from "./CellAccordion";

const { useProjectContext, useProjectActions } = require("@contexts/projects")

const RenderCostCenter = ({ units }) => {
  const [isOpen, setIsOpen] = useState(true)

  return <>
    {checkIfMultipleIds() && <>
      <div className="wbs-accordion-divider flex gap-4" onClick={() => setIsOpen(!isOpen)}>
        <button
          className={`accordion-toggle ${isOpen ? "active" : ""}`}
        />
        <h2>{units[0].wbs_code_id_building}</h2>
      </div>
      <div className="hr-simulator" />
    </>}
    {(isOpen) && units.map((item, index) =>
      <TableItem
        item={item}
        type={"unit"}
        typeTitle={"Unidade construtiva"}
        ChildAccordionComponent={item.building_unit_name === 'ITENS SEM APROPRIAÇÃO' ? null : CellAccordion}
      />
    )
    }
  </>

}

const UnitAccordion = () => {
  const { barChartDate } = useDashboardUIContext()
  const { activeProject: { _id, units }, filterDates } = useProjectContext();
  const { loadUnits } = useProjectActions();

  useEffect(() => {
    if (_id) {
      loadUnits(barChartDate);
    }
  }, [_id, filterDates, barChartDate])

  return (
    <div className="accordion margin-top-24">
      <ProjectionLoadState
        level="units"
        isMissing={!units}
        onRetry={() => loadUnits(barChartDate)}
      />
      {units && unitsIntoArray().map(i => {
        return <RenderCostCenter units={i} />
      })}
    </div>
  )
}

export default UnitAccordion;
